module.exports = __webpack_public_path__ + "static/media/logo-horizontal-white.eaa26d2f.png";